require('froala-editor/js/froala_editor.pkgd.min.js')
require('froala-editor/js/plugins/font_family.min.js')
require('froala-editor/js/plugins/align.min.js')
require('froala-editor/js/plugins/code_view.min.js')
require('froala-editor/js/plugins/font_size.min.js')
require('froala-editor/js/plugins/line_height.min.js')
require('froala-editor/js/plugins/paragraph_format.min.js')
require('froala-editor/js/plugins/paragraph_style.min.js')
require('froala-editor/js/plugins/image.min.js')
require('froala-editor/js/plugins/image_manager.min.js')
require('froala-editor/js/plugins/colors.min.js')
require('froala-editor/js/plugins/lists.min.js')
require('froala-editor/js/plugins/link.min.js')
require('froala-editor/js/plugins/quick_insert.min.js')
require('froala-editor/js/plugins/inline_class.min.js')
require('froala-editor/css/froala_editor.pkgd.min.css')
require('froala-editor/css/froala_style.min.css')
require('froala-editor/css/plugins/image.min.css')
require('froala-editor/css/plugins/image_manager.min.css')
require('froala-editor/css/plugins/quick_insert.min.css')
